import { customLogger } from "@/utils";

const state = {
  popupClosed: false,
  popupSeen: false,
  pageScrolled: false,
  waited10s: false,
  modle3D: false,
  virtual: false
}

const mutations = {
  SCROLLED_PAGE: (state) => {
    state.pageScrolled = true
  },
  WAITED_10_S: (state) => {
    state.waited10s = true
  },
  OPEN_POPUP: (state) => {
    state.popupClosed = false
    state.popupSeen = true
  },
  CLOSE_POPUP: (state) => {
    customLogger("CLOSE_POPUP IN SESSION_NAVIGATION")
    state.popupClosed = true
    state.popupSeen = true
  }
}

export default {
  state,
  mutations
}
